import { useState } from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'

import { PublicRoutes } from './PublicRoutes'
import { ErrorBoundary, ErrorScreen } from '../components'
import Layout from '../components/Layout/Layout'
import { useUser } from '../context'
import { DashboardPage, InitialForm, ProfilePage } from '../pages'
import StudentsPage from '../pages/StudentsPage'
import { StudentMenu, URLNavigation } from '../types'

export const PrivateRoutesStudents = () => {
  const [classToggle, setClassToggle] = useState<string>('class')

  // TODO: replace with
  // const { loadingUser, userRole, loadError } = useUser()
  // const { studentsLoading, studentsError } = useStudents()
  // if (loadError) return <ErrorScreen />
  // if (loadError) {
  //   return <ErrorScreen message="No pudimos validar tu sesión." />
  // }

  // if (loadingUser) {
  //   return <Spinner />  // o el componente que prefieras
  // }

  // if (studentsError) {
  //   return <ErrorScreen message={studentsError} />
  // }

  // if (studentsLoading) {
  //   return <Spinner />
  // }

  const { userRole, loadingUser, initDone } = useUser()

  if (loadingUser || !initDone) {
    return <div>Loading...</div>
  }

  return (
    // <BrowserRouter>
    <ErrorBoundary fallback={<ErrorScreen />}>
      <Layout setClassToggle={setClassToggle}>
        {userRole && initDone ? (
          <Routes>
            <Route
              index
              element={<StudentsPage part="dashboard" type={classToggle} />}
            />
            <Route
              path="/"
              element={<StudentsPage part="dashboard" type={classToggle} />}
            />
            <Route path="/initial-form" element={<InitialForm />} />
            <Route path="/dashboard" element={<DashboardPage />} />

            <Route path="/perfil" element={<ProfilePage />} />

            <Route
              path={`${URLNavigation.ROUTINE}`}
              element={<StudentsPage part={StudentMenu.routine.label} />}
            />

            <Route
              path={`${URLNavigation.ROUTE}`}
              element={<StudentsPage part={StudentMenu.route.label} />}
            />

            <Route
              path={URLNavigation.CHAT}
              element={<StudentsPage part={StudentMenu.chat.label} />}
            />

            <Route
              path={`profesor/:professorName`}
              element={
                <StudentsPage part={StudentMenu.professorProfile.label} />
              }
            />

            <Route
              path="/desafios"
              element={<StudentsPage part="admin-challenge" />}
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <Route path="/*" element={<PublicRoutes />} />
        )}
      </Layout>
      {/* </BrowserRouter> */}
    </ErrorBoundary>
  )
}
